import { Action, combineReducers, createFeatureSelector, createSelector } from "@ngrx/store";
import { selectTransactionFormTransactionDetails } from "../../create-request/reducers";
import { TrustTaxCategory } from "../../shared/types/TrustTaxCategory";
import * as fromViewDetailsState from './view-details.reducers';

export const transactionViewFeatureKey = 'transactionView';

export interface TransactionViewState {
    [fromViewDetailsState.viewDetailsKey]: fromViewDetailsState.State
}

export function reducers(
    state: TransactionViewState | undefined,
    action: Action
) {
    return combineReducers({
        [fromViewDetailsState.viewDetailsKey]: fromViewDetailsState.viewDetailsReducer
    })(state, action);
}

export const selectTransactionView = createFeatureSelector<TransactionViewState>(
    transactionViewFeatureKey
);

export const selectViewDetails = createSelector(
    selectTransactionView,
    (state) => {
        return state.viewDetails;
    }
);

export const selectCashieringRequestId = createSelector(
    selectViewDetails,
    (state) => {
        return state.cashieringRequestId;
    }
);

export const selectCashieringRequestSecondId = createSelector(
    selectViewDetails,
    (state) => {
        return state.cashieringRequestSecondId;
    }
);

export const selectViewFrequency = createSelector(
    selectViewDetails,
    (state) => {
        return state.frequency
    }
)

export const selectIsStandingAuthViewPage = createSelector(
    selectViewDetails, (state) => {
        return state.type === 'standing-auth';
    }
);

export const selectIsTransactionsViewPage = createSelector(
    selectViewDetails, (state) => {
        return state.type === 'transaction';
    }
);

export const selectIsIncoming = createSelector(
    selectViewDetails, (state) => {
        return state.isIncoming;
    }
);

export const selectIsCancelable = createSelector(selectViewDetails, (state) => {
    return state.isCancelable;
});

export const selectIsEditable = createSelector(selectViewDetails, (state) => {
    return state.isEditable;
})

export const selectIsEAuth = createSelector(selectViewDetails, (state) => {
    return state.eAuthStatus?.isEAuth;
});

export const selectIsEauthForEditFlow = createSelector(selectViewDetails, (state) => {
    return state.isEauthForEditFlow;
});

export const selectDistributionReason = createSelector(selectViewDetails, (state) => {
    return state.distributionReason;
});

export const selectDistributionReasonsList = createSelector(selectViewDetails, (state) => {
    return state.distributionReasonsList;
});

export const selectTaxWithholding = createSelector(selectViewDetails, (state) => {
    return state.taxWithholding;
});

export const selectTrustTaxCategoriesAndCodesFromInquiry = createSelector(selectViewDetails, (state) => {
    return state.trustTaxCategoriesAndCodes;
});

export const selectTrustTaxCategoriesFromInquiry = createSelector(selectTrustTaxCategoriesAndCodesFromInquiry, (state) => {
    return Object.keys(state).filter(category => category !== ' ---Select--- ') as TrustTaxCategory[];
});

export const selectTrustTaxCodesFromInquiry = createSelector(
    selectTrustTaxCategoriesAndCodesFromInquiry,
    selectTransactionFormTransactionDetails,
    (categoriesAndCodes, details) => {
        if (details?.trustTaxCategory) {
            return categoriesAndCodes[details.trustTaxCategory as TrustTaxCategory] ?? [];
        }
        return [];
    }
);

export const selectInquiryCallComplete = createSelector(selectViewDetails, (state) => {
    return state.inquiryCallComplete;
})

export const selectViewPageTransactionType = createSelector(selectViewDetails, (state) => {
    return state.transactionType;
});

